import { MessageActionTypes } from '@weblite/ts-action/message'
import { useSelector } from 'react-redux'
import { RootState } from '$setup/redux'

export function useMessageAction(
  roomId: string = '',
): { userId: string; action: MessageActionTypes }[] {
  return useSelector((state: RootState) => state.main.messageActions[roomId])
}
